import { useEffect, useState } from "react";

const KEY = "sh_units";
const EVT = "sh-units";

export function useUnits() {
  const [unit, setUnit] = useState(() => localStorage.getItem(KEY) || "ft");
  useEffect(() => {
    const on = () => setUnit(localStorage.getItem(KEY) || "ft");
    window.addEventListener(EVT, on);
    return () => window.removeEventListener(EVT, on);
  }, []);
  const toggle = () => {
    localStorage.setItem(KEY, unit === "ft" ? "m" : "ft");
    window.dispatchEvent(new Event(EVT));
  };
  return [unit, toggle];
}

const toMetres = (s) => {
  const ft = s.match(/(\d+(?:\.\d+)?)\s*['′]\s*(?:(\d+(?:\.\d+)?)\s*["″]?)?/);
  if (ft) return (parseFloat(ft[1]) * 12 + parseFloat(ft[2] || 0)) * 0.0254;
  const m = s.match(/(\d+(?:\.\d+)?)/);
  return m ? parseFloat(m[1]) : null;
};

const ftIn = (m) => {
  const total = Math.round(m / 0.0254);
  return `${Math.floor(total / 12)}'${total % 12}"`;
};

export function fmtDims(text, unit) {
  if (!text) return "";
  const parts = text.split(/\s*[×x]\s*/i);
  const vals = parts.map(toMetres);
  if (parts.length < 2 || vals.some((v) => v == null)) return text;
  return unit === "m" ? `${vals.map((v) => v.toFixed(1)).join(" × ")} m` : vals.map(ftIn).join(" × ");
}

export function useDims() {
  const [unit] = useUnits();
  return (t) => fmtDims(t, unit);
}
